import Vue from "vue";
import Vuex from "vuex";

// 供其他页面导入
window.Vuex = Vuex;

import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  getters,
});

export default store;
